const fr = {
  common: {
    loading: "Chargement…",
    loadingAlt: "Chargement",
    continue: "Continuer",
    retry: "Réessayer",
    goBack: "Retour",
    logout: "Déconnexion",
    logOut: "Se déconnecter",
    email: "E-mail",
    password: "Mot de passe",
  },

  errors: {
    firebase: {
      unexpected: "Une erreur inattendue s'est produite. Veuillez réessayer.",
      invalidCredential: "E-mail ou mot de passe invalide. Veuillez vérifier vos identifiants et réessayer.",
      userNotFound: "Aucun compte trouvé avec cet e-mail. Veuillez d'abord créer un compte.",
      emailAlreadyInUse: "Un compte avec cet e-mail existe déjà. Veuillez vous connecter.",
      weakPassword: "Le mot de passe est trop faible. Veuillez utiliser au moins 6 caractères.",
      invalidEmail: "Adresse e-mail invalide. Veuillez saisir une adresse valide.",
      userDisabled: "Ce compte a été désactivé. Veuillez contacter le support.",
      tooManyRequests: "Trop de tentatives échouées. Veuillez réessayer plus tard ou réinitialiser votre mot de passe.",
      networkRequestFailed: "Erreur réseau. Veuillez vérifier votre connexion Internet et réessayer.",
      requiresRecentLogin: "Veuillez vous reconnecter pour effectuer cette action.",
      popupClosedByUser: "Connexion annulée. Veuillez réessayer.",
      popupBlocked: "Fenêtre contextuelle bloquée. Veuillez autoriser les fenêtres contextuelles pour ce site et réessayer.",
      cancelledPopupRequest: "Connexion annulée. Veuillez réessayer.",
      operationNotAllowed: "Cette méthode de connexion n'est pas activée. Veuillez contacter le support.",
      accountExistsWithDifferentCredential: "Un compte existe déjà avec le même e-mail mais une méthode de connexion différente. Veuillez utiliser votre méthode de connexion d'origine.",
      credentialAlreadyInUse: "Cet identifiant est déjà associé à un autre compte.",
      invalidVerificationCode: "Code de vérification invalide. Veuillez réessayer.",
      invalidVerificationId: "ID de vérification invalide. Veuillez recommencer le processus de vérification.",
      missingVerificationCode: "Veuillez saisir le code de vérification.",
      missingVerificationId: "L'ID de vérification est manquant. Veuillez recommencer le processus de vérification.",
      permissionDenied: "Vous n'avez pas l'autorisation d'effectuer cette action.",
      unavailable: "Service temporairement indisponible. Veuillez réessayer dans un instant.",
      deadlineExceeded: "La requête a expiré. Veuillez réessayer.",
      notFound: "La ressource demandée est introuvable.",
      alreadyExists: "Cette ressource existe déjà.",
      resourceExhausted: "Limite du service dépassée. Veuillez réessayer plus tard.",
      failedPrecondition: "L'opération a échoué. Veuillez vous assurer que toutes les conditions sont remplies.",
      aborted: "L'opération a été interrompue. Veuillez réessayer.",
      outOfRange: "Plage spécifiée invalide.",
      unimplemented: "Cette fonctionnalité n'est pas encore disponible.",
      internal: "Erreur interne du serveur. Veuillez réessayer plus tard.",
      dataLoss: "Perte ou corruption de données détectée. Veuillez contacter le support.",
      unauthenticated: "Veuillez vous connecter pour continuer.",
      networkError: "Erreur réseau. Veuillez vérifier votre connexion Internet.",
      timeoutError: "La requête a expiré. Veuillez réessayer.",
      genericError: "Une erreur s'est produite. Veuillez réessayer ou contacter le support si le problème persiste.",
    },

    payment: {
      default: "Impossible de traiter le paiement. Veuillez réessayer.",
      cardDeclined: "Votre carte a été refusée. Veuillez vérifier les informations de votre carte ou essayer un autre moyen de paiement.",
      cardExpired: "Votre carte a expiré. Veuillez utiliser une autre carte.",
      cardIncorrect: "Les informations de la carte sont incorrectes. Veuillez vérifier et réessayer.",
      network: "Erreur réseau. Veuillez vérifier votre connexion et réessayer.",
      cardNotFound: "Informations de carte introuvables. Veuillez saisir à nouveau les détails de votre carte.",
      authenticationFailed: "Échec de l'authentification du paiement. Veuillez réessayer.",
      customerFailed: "Impossible de créer le compte client. Veuillez réessayer.",
      subscriptionFailed: "Impossible de créer l'abonnement. Veuillez réessayer.",
      genericWithSupport: "Impossible de traiter le paiement. Veuillez réessayer ou contacter le support.",
    },

    stripe: {
      failedPaymentIntent: "Échec de la création de l'intention de paiement",
      failedCheckoutSession: "Échec de la création de la session de paiement",
      subscriptionIdRequired: "L'ID d'abonnement est requis",
      failedCancelSubscription: "Échec de l'annulation de l'abonnement",
      failedResumeSubscription: "Échec de la reprise de l'abonnement",
      userIdAndPriceRequired: "L'ID utilisateur et le nouvel ID de prix sont requis",
      failedUpdateSubscription: "Échec de la mise à jour de l'abonnement",
    },

    stripePricing: {
      fetchPrices: "Échec de la récupération des prix",
      invalidCoupon: "Code promo invalide",
      validateCoupon: "Échec de la validation du code promo",
      fetchPromoCodes: "Échec de la récupération des codes promotionnels",
      getCustomer: "Échec de l'obtention ou de la création du client",
      createSubscription: "Échec de la création de l'abonnement",
      getSubscription: "Échec de l'obtention de l'abonnement",
    },

    promoCode: {
      default: "Impossible d'utiliser le code promo. Veuillez réessayer.",
      invalidCode: "Code promo invalide",
      expired: "Ce code promo a expiré.",
      activeCode: "Vous avez déjà un code actif. Veuillez attendre son expiration avant d'en utiliser un autre.",
      serviceUnavailable: "Le service de codes promo est temporairement indisponible. Veuillez réessayer plus tard.",
      unauthenticated: "Veuillez vous connecter pour utiliser un code promo.",
      permissionDenied: "Vous n'avez pas l'autorisation d'utiliser ce code promo.",
      invalidArgument: "Format de code promo invalide. Veuillez vérifier et réessayer.",
      deadlineExceeded: "La requête a expiré. Veuillez réessayer.",
      resourceExhausted: "Le service est occupé. Veuillez réessayer dans un instant.",
      failedPrecondition: "Impossible d'utiliser ce code promo pour le moment.",
      aborted: "L'utilisation a été annulée. Veuillez réessayer.",
      alreadyExists: "Ce code promo a déjà été utilisé.",
      unavailable: "Le service est actuellement indisponible. Veuillez réessayer plus tard.",
      internalError: "Une erreur s'est produite. Veuillez contacter le support si cela persiste.",
      corsError: "Erreur de connexion. Veuillez actualiser la page et réessayer.",
      networkError: "Erreur réseau. Veuillez vérifier votre connexion et réessayer.",
    },
  },

  password: {
    mustContain: "Le mot de passe doit contenir {requirements}",
    minLength: "au moins 8 caractères",
    uppercase: "une lettre majuscule",
    lowercase: "une lettre minuscule",
    number: "un chiffre",
    specialCharacter: "un caractère spécial",
    ensureRequirements: "Veuillez vous assurer que votre mot de passe répond à toutes les exigences",
    requirements: {
      minLength: "Au moins 8 caractères",
      uppercase: "Une lettre majuscule",
      lowercase: "Une lettre minuscule",
      number: "Un chiffre",
      specialCharacter: "Un caractère spécial (!@#$%^&*...)",
    },
  },

  login: {
    heading: "Connectez-vous à votre compte URUNN",
    marketingOptIn: "Soyez les premiers informés des nouveautés, des événements et des conseils d'entraînement d'experts – directement dans votre boîte de réception. Désabonnez-vous à tout moment.",
    loggingIn: "Connexion en cours...",
    divider: "Ou connectez-vous avec",
    googleButton: "Se connecter avec Google",
    appleButton: "Se connecter avec Apple",
    noAccount: "Vous n'avez pas de compte ?",
    signUpLink: "S'inscrire",
    verifyEmailBeforeLogin: "Veuillez vérifier votre e-mail avant de vous connecter. Consultez votre boîte de réception pour le lien de vérification.",
    emailNotVerifiedConfirm: "Votre e-mail n'est pas vérifié. Souhaitez-vous que nous renvoyions l'e-mail de vérification ?",
    verificationEmailSent: "E-mail de vérification envoyé ! Veuillez consulter votre boîte de réception.",
    failedToSendVerification: "Échec de l'envoi de l'e-mail de vérification",
    verifyEmailShort: "Veuillez vérifier votre e-mail avant de vous connecter.",
  },

  signup: {
    heading: "Créez votre compte URUNN",
    marketingOptIn: "Soyez les premiers informés des nouveautés, des événements et des conseils d'entraînement d'experts – directement dans votre boîte de réception. Désabonnez-vous à tout moment.",
    creatingAccount: "Création du compte...",
    divider: "Ou inscrivez-vous avec",
    googleButton: "S'inscrire avec Google",
    appleButton: "S'inscrire avec Apple",
    legalPrefix: "En vous inscrivant à URUNN, vous acceptez nos",
    termsLink: "Conditions générales (CLUF)",
    legalAnd: "et notre",
    privacyLink: "Politique de confidentialité",
    haveAccount: "Vous avez déjà un compte ?",
    loginLink: "Se connecter",
    verifyHeading: "Vérifiez votre e-mail",
    verifyEmailSent: "Nous avons envoyé un e-mail de vérification à",
    verifyCheckInbox: "Veuillez consulter votre boîte de réception et cliquer sur le lien de vérification pour activer votre compte.",
    verifyCheckingStatus: "✓ Vérification automatique du statut...",
    resending: "Renvoi en cours...",
    resendVerification: "Renvoyer l'e-mail de vérification",
    alreadyVerified: "Déjà vérifié ?",
    verificationResent: "E-mail de vérification renvoyé avec succès !",
    failedToResend: "Échec du renvoi de l'e-mail de vérification",
    emailAlreadyRegisteredVerify: "Cet e-mail est déjà enregistré. Veuillez vérifier votre e-mail avant de vous connecter.",
    emailAlreadyRegisteredPassword: "Cet e-mail est déjà enregistré. Veuillez vérifier votre mot de passe ou utiliser la page de connexion.",
    failedToSendVerification: "Échec de l'envoi de l'e-mail de vérification",
  },

  verifyEmail: {
    heading: "Vérifiez votre e-mail",
    sentTo: "Nous avons envoyé un e-mail de vérification à",
    checkInbox: "Veuillez consulter votre boîte de réception et cliquer sur le lien de vérification pour activer votre compte.",
    checkingStatus: "✓ Vérification automatique du statut...",
    resend: "Renvoyer l'e-mail de vérification",
    resending: "Renvoi en cours...",
    resent: "E-mail de vérification renvoyé avec succès !",
    failedToResend: "Échec du renvoi de l'e-mail de vérification",
    useDifferentAccount: "Utiliser un autre compte",
  },

  emailAction: {
    processing: "Traitement en cours...",
    pleaseWait: "Veuillez patienter pendant que nous vérifions votre demande",
    invalidRequest: "Demande invalide",
    emailVerified: "Votre e-mail a été vérifié",
    verificationExpired: "Ce lien de vérification a expiré ou a déjà été utilisé",
    verifyFailed: "Échec de la vérification de l'e-mail. Veuillez réessayer.",
    enterNewPassword: "Saisissez votre nouveau mot de passe",
    resetExpired: "Ce lien de réinitialisation du mot de passe a expiré ou a déjà été utilisé",
    invalidResetLink: "Lien de réinitialisation du mot de passe invalide",
    passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
    passwordResetSuccess: "Votre mot de passe a été réinitialisé avec succès",
    resetFailed: "Échec de la réinitialisation du mot de passe. Veuillez réessayer.",
    signInMessage: "Vous pouvez maintenant vous connecter avec votre nouveau compte",
    emailChanged: "Votre adresse e-mail a été mise à jour",
    emailRecovered: "Votre adresse e-mail a été restaurée",
    emailChangeFailed: "Ce lien a expiré ou a déjà été utilisé",
    resetPasswordTitle: "Réinitialisez votre mot de passe",
    enterNewPasswordBelow: "Saisissez votre nouveau mot de passe ci-dessous",
    newPasswordPlaceholder: "Nouveau mot de passe",
    confirmPasswordPlaceholder: "Confirmer le mot de passe",
    resetPasswordButton: "Réinitialiser le mot de passe",
    errorTitle: "Erreur",
    goToLogin: "Aller à la connexion",
  },

  billing: {
    stripeNotLoaded: "Stripe n'est pas encore chargé. Veuillez réessayer.",
    deferredBillingLabel: "Facturation différée :",
    deferredBillingMessage: "Vous ne serez débité qu'à la fin de votre période promotionnelle, le {date}.",
    emailLabel: "E-mail",
    cardNumberLabel: "Numéro de carte",
    expirationDateLabel: "Date d'expiration",
    securityCodeLabel: "Code de sécurité",
    countryLabel: "Pays",
    postalCodeLabel: "Code postal",
    processing: "Traitement en cours...",
    startTrial: "Commencer l'essai",
    securityNotice: "Paiement sécurisé par Stripe. Les informations de votre carte sont chiffrées et ne sont jamais stockées.",
    termsOfService: "En vous abonnant, vous acceptez nos Conditions d'utilisation",
    autoRenew: "Votre abonnement se renouvellera automatiquement sauf annulation",
    cancelAnytime: "Vous pouvez annuler à tout moment depuis les paramètres de votre compte",
    subscriptionStarted: "Abonnement démarré avec succès !",
    paymentAuthFailed: "Échec de l'authentification du paiement. Veuillez réessayer.",
    updatingPlan: "Mise à jour de votre forfait...",
    subscribeTo: "S'abonner à",
    defaultDiscountName: "Réduction",
    discountApplied: "{name} appliqué : économisez {amount}",
    freeTrial: "{duration} d'essai gratuit",
    monthlyPrice: "{price} / mois",
    monthlyPriceAfterTrial: "{price} / mois après l'essai gratuit",
    currentSubscription: "Abonnement actuel",
    remaining: "Restant",
    until: "Jusqu'au",
    chargedOn: "Vous serez débité le",
    afterTrialEnds: "Après la fin de l'essai, le {date}",
    totalDueToday: "Total dû aujourd'hui",
    dueToday: "Dû aujourd'hui",
    planUpdate: "Mise à jour du forfait",
    planUpdateMessage: "Votre abonnement sera mis à jour immédiatement.",
    updating: "Mise à jour...",
    confirmChange: "Confirmer le changement",
    noPaymentRequired: "Aucune information de paiement requise. Votre moyen de paiement existant sera utilisé.",
    planUpdatedSuccess: "Forfait mis à jour avec succès !",
    failedToUpdatePlan: "Échec de la mise à jour du forfait. Veuillez réessayer.",
  },

  offers: {
    loadingOffers: "Chargement des offres",
    noPlansAvailable: "Aucun forfait d'abonnement disponible",
    failedToLoadPlans: "Échec du chargement des forfaits d'abonnement. Veuillez réessayer.",
    title: "Gérer l'abonnement",
    currentPlan: "Forfait actuel",
    percentOff: "{percent}% DE RÉDUCTION",
    enterCouponCode: "Saisir le code de réduction",
    validating: "Validation...",
    apply: "Appliquer",
    enterPromoCode: "Saisir le code promo",
    redeeming: "Utilisation...",
    redeem: "Utiliser",
    haveCodeRedeem: "Vous avez un code promo ? Utilisez-le",
    continueToPayment: "Continuer vers le paiement",
    noPlansMessage: "Aucun forfait d'abonnement disponible pour le moment.",
    redeemingPromo: "Utilisation du code promo...",
    enterPromoCodeError: "Veuillez saisir un code promo",
    loginToRedeem: "Veuillez vous connecter pour utiliser un code promo",
    enterCouponCodeError: "Veuillez saisir un code de réduction",
    selectPlanFirst: "Veuillez d'abord sélectionner un forfait",
    unableToValidateCoupon: "Impossible de valider le code de réduction pour ce forfait.",
    couponApplied: "Code de réduction appliqué ! {discount}",
    couponExpired: "Ce code de réduction a expiré",
    couponLimitReached: "Ce code de réduction a atteint sa limite d'utilisation",
    invalidCouponCode: "Code de réduction invalide",
    couponNotValidForPlan: "Ce code de réduction n'est pas valide pour le forfait sélectionné",
    unableToValidate: "Impossible de valider le code de réduction. Veuillez réessayer.",
    promoRedeemButNotActive: "Code promo utilisé mais abonnement non actif. Veuillez contacter le support.",
    unableToRedeemPromo: "Impossible d'utiliser le code promo. Veuillez réessayer.",
    save: "Économisez {amount}",
  },

  subscription: {
    loading: "Chargement de l'abonnement",
    failedToLoad: "Échec du chargement des détails de l'abonnement. Veuillez réessayer.",
    noSubscription: "Aucun abonnement trouvé. Redirection vers les offres...",
    title: "Votre abonnement",
    planLabel: "Forfait",
    statusLabel: "Statut",
    platformLabel: "Plateforme",
    priceLabel: "Prix",
    startedLabel: "Démarré",
    renewsLabel: "Renouvellement",
    expiresLabel: "Expire",
    expiryDateLabel: "Date d'expiration",
    statusFreeTrial: "Essai gratuit",
    statusActive: "Actif",
    statusCancelled: "Annulé",
    trialBannerTitle: "Période d'essai gratuit",
    trialBannerMessage: "Votre essai se termine le {date}. Vous serez débité après cette date sauf si vous annulez.",
    cancelledBannerTitle: "Abonnement annulé",
    cancelledBannerMessage: "Votre abonnement a été annulé et ne sera pas renouvelé. Vous y avez toujours accès jusqu'au {date}.",
    billingIssue: "Il y a un problème avec votre moyen de paiement. Veuillez le mettre à jour pour continuer votre abonnement.",
    upgradePlan: "Améliorer le forfait",
    changePlan: "Changer de forfait",
    cancelSubscription: "Annuler l'abonnement",
    cancelling: "Annulation...",
    promoNote: "Votre accès promotionnel expire le {date}. Améliorez votre forfait pour continuer à y accéder après cette date.",
    stripeNote: "Changez de forfait ou annulez à tout moment. Vous continuerez à y avoir accès jusqu'au {date}.",
    resumeSubscription: "Reprendre l'abonnement",
    resuming: "Reprise...",
    accessEnds: "Votre accès se termine le {date}. Reprenez pour continuer votre abonnement.",
    manageSubscription: "Gérer l'abonnement",
    manageViaStore: "Gérez votre abonnement via {store}.",
    manageViaStoreGeneric: "Pour annuler ou modifier votre abonnement, veuillez le gérer via {store}.",
    promotionalAlert: "Il s'agit d'un abonnement promotionnel. Veuillez contacter le support pour le gérer.",
    nonStripeAlert: "Pour annuler votre abonnement, veuillez contacter le support ou le gérer via la boutique où vous l'avez acheté.",
    confirmCancel: "Êtes-vous sûr de vouloir annuler votre abonnement ? Vous continuerez à y avoir accès jusqu'à la fin de votre période de facturation actuelle.",
    cancelledDefault: "Abonnement annulé avec succès. Vous y aurez accès jusqu'à la fin de votre période de facturation actuelle.",
    failedToCancel: "Échec de l'annulation de l'abonnement. Veuillez réessayer ou contacter le support.",
    noSubscriptionId: "Impossible de trouver l'ID d'abonnement. Veuillez contacter le support.",
    confirmResume: "Êtes-vous sûr de vouloir reprendre votre abonnement ? Votre abonnement continuera et vous serez débité à la prochaine date de facturation.",
    failedToResume: "Échec de la reprise de l'abonnement. Veuillez réessayer ou contacter le support.",
    manageSubscriptionAlert: "Pour annuler ou modifier votre abonnement, veuillez contacter le support ou le gérer via la boutique où vous l'avez acheté.",
    downloadApp: "Télécharger l'application",
    scanToDownload: "Scannez pour télécharger",
    downloadAppCta: "Télécharger l'application",
    customPlan: "Personnalisé",
    storeName: {
      appStore: "Apple App Store",
      playStore: "Google Play Store",
      stripe: "Stripe",
      promotional: "Promotionnel",
    },
  },

  stripe: {
    cancelledAtPeriodEnd: "L'abonnement sera annulé le {date}",
    cancelledImmediately: "Abonnement annulé immédiatement",
    resumedSuccessfully: "Abonnement repris avec succès. Votre abonnement continuera automatiquement.",
    updatedSuccessfully: "Abonnement mis à jour avec succès.",
  },

  promoCode: {
    redeemSuccess: "Code promo utilisé avec succès !",
  },

  stripePricing: {
    percentOff: "{percent}% DE RÉDUCTION",
    amountOff: "{amount} DE RÉDUCTION",
    savings: "Économisez {amount}",
  },
  onboarding: {
    welcomeHeading: "Votre coach de course propulsé par l'IA",
    getStarted: "Commencer",
    haveAccount: "J'ai déjà un compte",
    continue: "Continuer",
    skip: "Passer",
    back: "Retour",
    createAccount: "Créez votre compte",
    nameFirstPlaceholder: "Prénom",
    nameLastPlaceholder: "Nom",
    nameRequired: "Veuillez saisir votre prénom et votre nom",
    dateRequired: "Veuillez sélectionner une date",
    ageMinimum: "Vous devez avoir au moins 13 ans",
    searchRacePlaceholder: "Rechercher une course...",
    customRace: "Course personnalisée",
    noRacesFound: "Aucune course trouvée",
    searching: "Recherche...",
    skipRace: "Je passe cette étape pour l'instant",
    additionalInfoPlaceholder: "Ex. : je reprends l'entraînement après une blessure persistante au mollet ; je pars en vacances dans 6 semaines et ne pourrai pas courir.",
    summaryEdit: "Modifier",
  },

  promo: {
    welcomeHeadline: "Bienvenue sur URUNN",
    welcomeSubtitle: "Votre coach de course propulsé par l'IA. Entraînez-vous plus intelligemment et courez à votre meilleur niveau.",
    signupSubtitle: "Saisissez vos informations pour débloquer votre accès gratuit et commencer à vous entraîner.",
    loginSubtitle: "Bon retour. Connectez-vous pour poursuivre votre entraînement.",
    getStarted: "Commencer",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    logIn: "Se connecter",
    successLead: "Votre prochaine meilleure course commence ici.",
    redeemHeadline: "Utilisez votre code",
    redeemSubtitle: "Saisissez votre code ci-dessous pour débloquer votre accès gratuit et commencer à vous entraîner.",
    successTitle: "FÉLICITATIONS !",
    redeemSuccessSub: "Votre abonnement est actif. Nous vous avons envoyé par e-mail un lien magique pour télécharger l'application et commencer.",
    viewSubscription: "Voir mon abonnement",
    // Shorter than the English "Click to Download the App" on purpose: the
    // literal translation wrapped to two lines in the pill CTA (three at
    // 320px). Matches subscription.downloadAppCta.
    downloadAppCta: "Télécharger l'application",
  },
} as const;

export default fr;
